const userLanguage = navigator.language
export const language = userLanguage.split('-')[0] === 'ru' ? 'ru' : 'en'
